import React from 'react';
import { Mic, Send, X } from 'lucide-react';

const ChatInput = ({ 
  inputText, 
  setInputText, 
  onSend,
  isListening,
  onStartListening,
  onStopListening,
  speechEnabled = false
}) => {
  return (
    <div className="flex p-4 border-t">
      <textarea 
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        placeholder="Add update on Mentee..."
        className="flex-grow mr-2 p-2 border rounded resize-none"
        rows={1}
        onKeyPress={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSend();
          }
        }}
      />
      
      {speechEnabled && (
        !isListening ? (
          <button 
            onClick={onStartListening}
            className="mr-2 p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            <Mic size={20} />
          </button>
        ) : (
          <button 
            onClick={onStopListening}
            className="mr-2 p-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            <X size={20} />
          </button>
        )
      )}

      <button 
        onClick={onSend}
        className="p-2 bg-green-500 text-white rounded hover:bg-green-600"
      >
        <Send size={20} />
      </button>
    </div>
  );
};

export default ChatInput;
